import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PublicPlayer from "./PublicPlayer"; // Die neue Datei importieren
import "./styles.css";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

// Wir prüfen, was oben in der Adresszeile steht
const path = window.location.pathname;

root.render(
  <React.StrictMode>
    {/* Logik: Wenn URL auf /radio endet, zeige den PublicPlayer, sonst die normale App */}
    {path === "/radio" || path === "/public" ? (
      <PublicPlayer />
    ) : (
      <App />
    )}
  </React.StrictMode>
);